import { Dialog, DialogTitle, DialogDescription, DialogBody, DialogActions } from '@/components/catalyst-ui/dialog'
import { Button } from '@/components/catalyst-ui/button'
import { Input } from '@/components/catalyst-ui/input'
import { Field, Label } from '@/components/catalyst-ui/fieldset'
import { XMarkIcon } from '@heroicons/react/24/solid'

export default function DeleteDNSRecordDialog({
  open,
  onClose,
  record,
  onConfirm,
  isLoading = false,
}) {
  if (!record) return null

  return (
    <Dialog open={open} onClose={onClose} className="!rounded-xl p-5 !bg-[#FAFAFA]">
      <div className="flex items-center justify-between">
        <DialogTitle className="!text-lg !font-semibold !text-[#09090B]">Delete DNS Record</DialogTitle>
        <button
          onClick={onClose}
          className="text-black hover:text-zinc-600 data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2 rounded-full"
        >
          <XMarkIcon className="w-5 h-5 -mt-6 -mr-2.5" />
        </button>
      </div>
      <DialogBody className="!mt-2">
        <DialogDescription className="!text-sm !font-medium !text-[#A1A1AA]">
          Are you sure you want to delete this DNS record? This action cannot be undone.
        </DialogDescription>
        <form className="space-y-3 mt-4">
          <Field>
            <Label className="text-sm font-medium text-gray-700">Type</Label>
            <Input
              type="text"
              value={record.type}
              readOnly
              className="!bg-white"
            />
          </Field>
          
          <Field>
            <Label className="text-sm font-medium text-gray-700">Host</Label>
            <Input
              type="text"
              value={record.host}
              readOnly
              className="!bg-white"
            />
          </Field>
          
          <Field>
            <Label className="text-sm font-medium text-gray-700">Value</Label>
            <Input
              type="text"
              value={record.value}
              readOnly
              className="!bg-white break-all"
            />
          </Field>
          
          {record.priority && (
            <Field>
              <Label className="text-sm font-medium text-gray-700">Priority</Label>
              <Input
                type="text"
                value={record.priority}
                readOnly
                className="!bg-white"
              />
            </Field>
          )}
          
          <Field>
            <Label className="text-sm font-medium text-gray-700">TTL</Label>
            <Input
              type="text"
              value={record.ttl}
              readOnly
              className="!bg-white"
            />
          </Field>
        </form>
      </DialogBody>
      <DialogActions className="!mt-4 !flex !flex-col sm:!flex-row !gap-3">
        <Button 
          onClick={onClose}
          outline
          className="w-full sm:flex-1 data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2"
        >
          Cancel
        </Button>
        <Button 
          onClick={onConfirm}
          outline
          disabled={isLoading}
          className="w-full sm:flex-1 !border !border-[#EF4444] !text-[#B91C1C] !bg-[#FEE2E2] !font-semibold hover:!bg-red-50 data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2"
          style={{ boxShadow: '0px 4px 6px -1px #0000001A, 0px 2px 4px -2px #0000001A' }}
        >
          {isLoading ? 'Deleting...' : 'Delete Record'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
